// @ts-nocheck
/**
 * @fileoverview TD Subscription Box Component
 * Custom element for handling subscription toggle functionality
 */

  class TdSubscriptionBox extends HTMLElement {
    constructor() {
      super();
      this.selectedOption = false;
      this.activeBox = this.querySelector(".active");
      this.oneTimeLabels = document.querySelectorAll(".your-are-saving-display");
      this.subLabels = document.querySelectorAll(".your-are-saving-display-subs");
    }

    connectedCallback() {
    document.addEventListener('variant:update', (event) => {
      this.updatePrices();
    });
    
    // Listen for variant selection events
    document.addEventListener('variant:selected', (event) => {
      let variantId = event.detail.resource.id;
      if (variantId && variantId.length < 15) {
        const variantPicker = document.querySelector('variant-picker');
        let foundVariantId = null;
        
        if (variantPicker) {
          const selectedInput = variantPicker.querySelector('input[type="radio"]:checked');
          const selectedSelect = variantPicker.querySelector('select');
          
          if (selectedInput && selectedInput.dataset.variantId) {
            foundVariantId = selectedInput.dataset.variantId;
          } else if (selectedSelect && selectedSelect.selectedIndex >= 0) {
            const selectedOption = selectedSelect.options[selectedSelect.selectedIndex];
            if (selectedOption && selectedOption.dataset.variantId) {
              foundVariantId = selectedOption.dataset.variantId;
            }
          }
        }
        
        if (foundVariantId) {
          variantId = foundVariantId;
        } else {
          const productForm = document.querySelector('form[action*="/cart/add"]');
          const variantInput = productForm?.querySelector('input[name="id"]');
          if (variantInput?.value) {
            variantId = variantInput.value;
          }
        }
      }
      
      this.handleVariantChange(variantId);
    });
    
    this.setupEventListeners();
    this.setSellingPlan();
  }
  
  setupEventListeners() {
    const activeContainer = this.querySelector('.td-subscription-box-container.active');
    if (!activeContainer) return;
    
    const sellingPlanSelectors = activeContainer.querySelectorAll(".td-subscription-toggle__frequency-select");
    const toggleInputs = activeContainer.querySelectorAll(".td-subscription-toggle__input");
    
    sellingPlanSelectors.forEach(selector => {
      selector.addEventListener('change', () => { 
        const container = selector.closest('.td-subscription-toggle');
        const toggle = container?.querySelector('.td-subscription-toggle__input');
        this.setSellingPlan(toggle);
      });
    });

    toggleInputs.forEach(toggle => {
      toggle.addEventListener('change', (event) => {
        this.handleToggleChange(event);
      });
      
      this.setInitialToggleState(toggle);
    });
  }
  
  /**
   * Handle variant change events
   * @param {string} variantId - The ID of the selected variant
   */
  handleVariantChange(variantId) {
    const variantDataScript = document.getElementById('subscription-variant-data');
    if (!variantDataScript) return;
    
    const variantData = JSON.parse(variantDataScript.textContent || '{}');
    const variantInfo = variantData.variants.find(v => v.id === variantId);
    
    if (!variantInfo) {
      this.style.display = 'none';
      return;
    }
    
    this.style.display = 'block';
    
    const currentContainer = this.querySelector('.td-subscription-box-container.active');
    const currentToggle = currentContainer?.querySelector('.td-subscription-toggle__input');
    const currentFrequency = currentContainer?.querySelector('.td-subscription-toggle__frequency-select');
    const wasSubscriptionSelected = currentToggle?.checked || false;
    const currentFrequencyValue = currentFrequency?.value || '';
    
    if (currentContainer) {
      currentContainer.remove();
    }
    
    const newContainer = this.createVariantContainer(variantInfo);
    this.appendChild(newContainer);
    
    this.setupEventListeners();
    const newToggle = newContainer.querySelector('.td-subscription-toggle__input');
    const newFrequency = newContainer.querySelector('.td-subscription-toggle__frequency-select');
    
    if (newToggle) {
      newToggle.checked = wasSubscriptionSelected;
      const frequencyContainer = newContainer.querySelector('.td-subscription-toggle__frequency');
      if (frequencyContainer) {
        frequencyContainer.style.display = wasSubscriptionSelected ? 'flex' : 'none';
      }
      
      if (wasSubscriptionSelected && newFrequency) {
        const sameFrequencyOption = newFrequency.querySelector(`option[value="${currentFrequencyValue}"]`);
        if (sameFrequencyOption) {
          newFrequency.value = currentFrequencyValue;
        } else {
          newFrequency.value = newFrequency.options[0]?.value || '';
        }
      }
      
      this.setSellingPlan(newToggle);
    }
  }
  
  /**
   * Create a variant container element
   */
  createVariantContainer(variantInfo) {
    const container = document.createElement('div');
    container.className = 'td-subscription-box-container active';
    container.setAttribute('data-variant-id', variantInfo.id);
    container.setAttribute('data-oneprice', variantInfo.price);
    container.setAttribute('data-spPickerPrice', variantInfo.spPickerPrice);
    const hasSubscription = variantInfo.hasSubscription;
    const discountPercentage = variantInfo.discountPercentage || 0;
    
    container.innerHTML = `
      <div class="td-subscription-toggle">
        <div class="td-subscription-toggle__container">
          <div class="td-subscription-toggle__switch">
            <input 
              type="checkbox" 
              id="td-subscription-toggle_${variantInfo.id}" 
              class="td-subscription-toggle__input" 
              name="selling_plan_select"
              value="subsave"
              data-variant-id="${variantInfo.id}"
              data-price="${variantInfo.spPickerPrice}"
              data-compare-at-price="${variantInfo.price}"
              data-onetime-available="true"
            >
            <label for="td-subscription-toggle_${variantInfo.id}" class="td-subscription-toggle__label">
              <span class="td-subscription-toggle__slider"></span>
            </label>
          </div>
          <div class="td-subscription-toggle__content">
            <div class="td-subscription-toggle__text">
              <span class="td-subscription-toggle__main-text">
                Subscribe & 
                <span class="td-subscription-toggle__discount-badge">
                  Save ${discountPercentage}%
                </span>
              </span>
              <span class="td-subscription-toggle__sub-text">
                Pause or Cancel Anytime
              </span>
            </div>
          </div>
        </div>
        ${hasSubscription && variantInfo.sellingPlans.length > 1 ? `
          <div class="td-subscription-toggle__frequency" style="display: none;">
            <label class="td-subscription-toggle__frequency-label">Delivery Every:</label>
            <select name="td-sp-picker__frequency-${variantInfo.id}" class="td-subscription-toggle__frequency-select">
              ${variantInfo.sellingPlans.map(plan => `
                <option value="${plan.id}">${plan.name}s</option>
              `).join('')}
            </select>
          </div>
        ` : ''}
      </div>
    `;
    
    return container;
  }
  
  /**
   * Set initial state for toggle switch and frequency selector
   * @param {HTMLInputElement} toggle - The toggle input element
   */
  setInitialToggleState(toggle) {
    const toggleContainer = toggle.closest('.td-subscription-toggle');
    if (!toggleContainer) return;
    
    const frequencySelector = toggleContainer.querySelector('.td-subscription-toggle__frequency');
    
    // Set initial visibility based on toggle state
    if (frequencySelector) {
      const element = /** @type {HTMLElement} */ (frequencySelector);
      element.style.display = toggle.checked ? 'flex' : 'none';
    }
  }
  
  /**
   * Handle toggle switch change events
   * @param {Event} event - The change event
   */
  handleToggleChange(event) {
    const toggle = event.target;
    
    if (!toggle || toggle.type !== 'checkbox') return;
    
    const toggleContainer = toggle.closest('.td-subscription-toggle');
    if (!toggleContainer) return;
    
    const frequencySelector = toggleContainer.querySelector('.td-subscription-toggle__frequency');
    
    if (frequencySelector) {
      frequencySelector.style.display = toggle.checked ? 'flex' : 'none';
    }
    
    this.setSellingPlan(toggle);
  }

  /**
   * Set the selling plan value based on toggle state
   */
  setSellingPlan(specificToggle = null) {
    let targetToggle;
    if (specificToggle) {
      targetToggle = specificToggle;
    } else {
      targetToggle = this.querySelector('.active .td-subscription-toggle__input');
    }
    
    if (!targetToggle || targetToggle.type !== 'checkbox') return;

    this.selectedOption = targetToggle.checked;
    
    const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) return;
    
    if (!this.selectedOption) {
      sellingPlanInput.value = "";
      this.updateVariantsPrice('block', 'none');
    } else {
      const toggleContainer = targetToggle.closest('.td-subscription-toggle');
      const frequencySelect = toggleContainer?.querySelector('.td-subscription-toggle__frequency-select');
      
      let sellingPlanId = "";
      
      if (frequencySelect) {
        sellingPlanId = frequencySelect.value;
      } else {
        const container = targetToggle.closest('.td-subscription-box-container');
        if (container) {
          const firstSellingPlan = container.querySelector('option[value]');
          if (firstSellingPlan) {
            sellingPlanId = firstSellingPlan.value;
          }
        }
      }
      
      sellingPlanInput.value = sellingPlanId;
      this.updateVariantsPrice('none', 'none');
    }
    
    // Update prices immediately for direct toggle changes (not variant changes)
    this.updatePrices();
  }


  updatePrices() {
    const activeContainer = this.querySelector('.active');
    if (!activeContainer || !activeContainer.dataset) return;

    if (!this.selectedOption) {
      const onePrice = activeContainer.dataset.oneprice || '0';
      this.updateProductPrice(activeContainer.dataset.oneprice, null);

    } else {
      const onePrice = activeContainer.dataset.oneprice || '0';
      const spPickerDiscountPrice = activeContainer.dataset.sppickerprice || '0';
      this.updateProductPrice(spPickerDiscountPrice, onePrice);
    }
  }

  /**
   * Update product price display
   * @param {string} salePrice - The sale price
   * @param {string|null} regularPrice - The regular price (null if no sale)
   */
  updateProductPrice(salePrice, regularPrice) {
    const productDetails = this.closest('.product-details');
    if (!productDetails) return;
    
    const productPriceComponent = productDetails.querySelector('product-price');
    if (!productPriceComponent) return;
    
    const priceContainer = productPriceComponent.querySelector('[ref="priceContainer"]');
    if (!priceContainer) return;
    
    if (regularPrice && salePrice !== regularPrice) {
      priceContainer.innerHTML = `
        <span role="group">
          <span class="visually-hidden">Regular price, </span>
          <span class="compare-at-price">${regularPrice}</span>
        </span>
        <span role="group">
          <span class="visually-hidden">Sale price, </span>
          <span class="price">${salePrice}</span>
        </span>
      `;
    } else {
      priceContainer.innerHTML = `
        <span class="price">${salePrice}</span>
      `;
    }
  }

  /**
   * Update variant price display visibility
   * @param {string} onetime - Display style for one-time labels
   * @param {string} sub - Display style for subscription labels
   */
  updateVariantsPrice(onetime, sub) {
      this.oneTimeLabels.forEach(
      (el) => {
        if (el) {
          const element = /** @type {HTMLElement} */ (el);
          element.style.display = onetime;
        }
      }
      );
      this.subLabels.forEach(
      (el) => {
        if (el) {
          const element = /** @type {HTMLElement} */ (el);
          element.style.display = sub;
        }
      }
    );
  }
}

if (!customElements.get("td-subscription-box")) {
  customElements.define("td-subscription-box", TdSubscriptionBox);
}
